export default {

    eventHeight: 20, // px

};
